export default {
  beneficiaries: [{ id: 0, nombres_apellidos: '', tipo_documento: 'CC', documento: '', celular: '', departamento: '', ciudad: '', porcentaje_asignado: '', showCiudad: false, showDepartamento: false, filteredCities: [], filteredStates: [] }],
}
